export const profileWhatsAppAccountsPageStyles = {
  page: {
    paddingBottom: 20,
  } as const,
  sectionCard: {
    borderRadius: 24,
    padding: '18px 16px',
    background: '#ffffff',
    border: '1px solid rgba(15, 23, 42, 0.05)',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
  } as const,
  sectionTitle: {
    fontSize: 32 / 2,
    lineHeight: 1.35,
    fontWeight: 800,
    color: '#1f2937',
  } as const,
  sectionSubtitle: {
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.6,
    color: '#8b95a7',
  } as const,
  plusButton: {
    width: 32,
    height: 32,
    border: 'none',
    background: 'transparent',
    color: '#6f6cf6',
    fontSize: 28,
    lineHeight: '32px',
    fontWeight: 400,
    padding: 0,
  } as const,
  accountCard: {
    borderRadius: 18,
    padding: '14px 14px 12px',
    background: '#ffffff',
    border: '1px solid rgba(112, 119, 255, 0.10)',
    boxShadow: '0 6px 18px rgba(31, 35, 41, 0.04)',
  } as const,
  accountTop: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
  } as const,
  accountIconWrap: {
    width: 40,
    height: 40,
    borderRadius: 14,
    background: 'rgba(111, 108, 246, 0.10)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6f6cf6',
    flexShrink: 0,
  } as const,
  accountMain: {
    minWidth: 0,
    flex: 1,
  } as const,
  phoneText: {
    fontSize: 17,
    fontWeight: 800,
    color: '#202437',
    lineHeight: 1.35,
    wordBreak: 'break-all',
  } as const,
  aliasRow: {
    marginTop: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    color: '#98a2b3',
    fontSize: 12,
    lineHeight: 1.4,
  } as const,
  rightMeta: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 6,
    flexShrink: 0,
  } as const,
  verifiedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 56,
    height: 24,
    padding: '0 10px',
    borderRadius: 999,
    background: 'rgba(132, 237, 216, 0.28)',
    color: '#2bc3a4',
    fontSize: 12,
    fontWeight: 700,
  } as const,
  unverifiedBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 56,
    height: 24,
    padding: '0 10px',
    borderRadius: 999,
    background: 'rgba(255, 199, 87, 0.20)',
    color: '#d99115',
    fontSize: 12,
    fontWeight: 700,
  } as const,
  defaultText: {
    fontSize: 11,
    fontWeight: 700,
    color: '#6f6cf6',
  } as const,
  statusRow: {
    marginTop: 12,
    borderRadius: 12,
    background: '#f6f7fb',
    padding: '10px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  } as const,
  statusDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    flexShrink: 0,
  } as const,
  statusLabel: {
    fontSize: 12,
    color: '#687082',
    fontWeight: 600,
  } as const,
  statusValue: {
    fontSize: 12,
    fontWeight: 800,
  } as const,
  actionsRow: {
    marginTop: 12,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  } as const,
  primaryActionButton: {
    height: 34,
    borderRadius: 12,
    padding: '0 14px',
    background: 'linear-gradient(90deg, #7d7af8 0%, #5c69f3 100%)',
    border: 'none',
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 700,
    boxShadow: '0 8px 18px rgba(92, 105, 243, 0.24)',
  } as const,
  outlineActionButton: {
    height: 34,
    borderRadius: 12,
    padding: '0 14px',
    background: '#ffffff',
    border: '1px solid rgba(111, 108, 246, 0.24)',
    color: '#6f6cf6',
    fontSize: 12,
    fontWeight: 700,
  } as const,
  dangerActionButton: {
    height: 34,
    borderRadius: 12,
    padding: '0 14px',
    background: '#ffffff',
    border: '1px solid rgba(255, 126, 126, 0.32)',
    color: '#ef6b6b',
    fontSize: 12,
    fontWeight: 700,
  } as const,
  actionContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
  } as const,
  bindSection: {
    borderRadius: 24,
    padding: '18px 16px 20px',
    background: '#ffffff',
    border: '1px solid rgba(15, 23, 42, 0.05)',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)',
  } as const,
  fieldLabel: {
    marginBottom: 8,
    fontSize: 14,
    fontWeight: 700,
    color: '#202437',
  } as const,
  requiredMark: {
    marginRight: 4,
    color: '#ff6b6b',
  } as const,
  inputShell: {
    borderRadius: 16,
    background: '#ffffff',
    border: '1px solid rgba(31, 35, 41, 0.10)',
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minHeight: 50,
  } as const,
  inputIcon: {
    color: '#98a2b3',
    flexShrink: 0,
  } as const,
  input: {
    '--font-size': '16px',
    '--placeholder-color': '#a3acbe',
    flex: 1,
    minWidth: 0,
  } as const,
  switchCard: {
    borderRadius: 16,
    background: '#f7f8fc',
    padding: '14px 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  } as const,
  switchTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: '#202437',
  } as const,
  switchHint: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 1.5,
    color: '#8b95a7',
  } as const,
  submitButton: {
    height: 46,
    borderRadius: 16,
    fontWeight: 700,
    background: 'linear-gradient(90deg, #7d7af8 0%, #5c69f3 100%)',
    boxShadow: '0 12px 28px rgba(92, 105, 243, 0.22)',
    border: 'none',
  } as const,
  securityNotice: {
    borderRadius: 18,
    padding: '14px 14px',
    background: 'rgba(118, 236, 214, 0.10)',
    border: '1px solid rgba(118, 236, 214, 0.24)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
  } as const,
  securityTitle: {
    fontSize: 13,
    fontWeight: 800,
    color: '#25b79a',
  } as const,
  securityText: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#5dbdaa',
  } as const,
  modeSwitchButton: {
    borderRadius: 999,
    padding: '4px 10px',
    fontWeight: 700,
    borderColor: 'rgba(23, 105, 255, 0.22)',
    color: '#1769ff',
    background: 'rgba(23, 105, 255, 0.04)',
  } as const,
  connectCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 0',
  } as const,
  pairingCodeBox: {
    width: '100%',
    borderRadius: 16,
    padding: '14px 12px',
    background: 'rgba(23, 105, 255, 0.06)',
    border: '1px solid rgba(23, 105, 255, 0.10)',
  } as const,
  pairingCodeText: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: 3,
    color: '#1769ff',
    textAlign: 'center',
    wordBreak: 'break-all',
  } as const,
  qrBox: {
    width: 260,
    height: 260,
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(32, 36, 55, 0.08)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  } as const,
  qrImage: {
    width: 240,
    height: 240,
    borderRadius: 12,
  } as const,
  connectErrorBox: {
    borderRadius: 16,
    padding: '12px 12px',
    border: '1px solid rgba(214, 76, 76, 0.18)',
    background: 'rgba(214, 76, 76, 0.06)',
  } as const,
} as const;
